
import { useStore } from "@/store";
import { defineComponent, onBeforeUnmount, ref, watch } from "vue";
import { useRouter } from "vue-router";
import FeedbackModal from "@/views/Home/components/modals/FeedbackModal.vue";
import ProfileModal from "@/views/Home/components/modals/ProfileModal.vue";

export default defineComponent({
  name: "TheHeader",
  components: { FeedbackModal, ProfileModal },
  setup() {
    const store = useStore();
    const router = useRouter();
    const showFeedbackModal = ref(false);
    const showProfileModal = ref(false);
    const showMobileMenu = ref(false);
    const logout = async () => {
      store.commit("setSelectedRateTypeId", null);
      store.commit("setCompany", {});
      store.commit("setHasSubscriptions", false);
      store.dispatch("logout");
      await router.push({ name: "auth.login" });
    };

    const handleOutsideClickOfMobileMenu = () => {
      showMobileMenu.value = false;
    };

    onBeforeUnmount(() => {
      if (showMobileMenu.value) document.removeEventListener("click", handleOutsideClickOfMobileMenu);
    });

    watch(showMobileMenu, (value) => {
      value
        ? document.addEventListener("click", handleOutsideClickOfMobileMenu)
        : document.removeEventListener("click", handleOutsideClickOfMobileMenu);
    });

    return {
      showFeedbackModal,
      showProfileModal,
      showMobileMenu,
      logout,
    };
  },
});
